import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import './App.css';
import $ from 'jquery';

class Footer extends Component {

    componentDidMount() {


        $( "#prodej-instalace-li" ).click(function() {
            $( ".dropdown" ).addClass("deactived");
        });
        $( "#lokalni-li" ).click(function() {
            $( ".dropdown" ).addClass("deactived");
        });
        $( "#outsourcing-li" ).click(function() {
            $( ".dropdown" ).addClass("deactived");
        });
        $( "#audit-is-li" ).click(function() {
            $( ".dropdown" ).addClass("deactived");
        });
        $( "#webhosting-li" ).click(function() {
            $( ".dropdown" ).addClass("deactived");
        });
        $( "#webdesign-li" ).click(function() {
            $( ".dropdown" ).addClass("deactived");
        });
        $( "#cenik-praci-li" ).click(function() {
            $( ".dropdown" ).addClass("deactived");
        });

        $(".dropdown").mouseover(function(){
            $( ".dropdown" ).removeClass("deactived");
        });
    }


  render() {
    return (
<div>

    <footer className="footer">
        <div className="container footer-container">
            <div className="col-sm-3 ">
                <div className="fb-like" data-href="https://www.facebook.com/profile.php?id=376798009127315" data-width="100" data-layout="button" data-action="like" data-size="small" data-show-faces="false" data-share="false"></div>

            </div>
            <div className="col-sm-9 right">
                Developed by <a href="mailto:strobl.v@gmail.com">Webmaster</a> | Copyright 2018-2024 © RICOM Tech s.r.o
            </div>
        </div>
    </footer>

</div>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/Footer.js